import { getVisualUnitParamsIndex } from '../../VisualunitHelpers'
import { Imeasures } from '../Reports/DashboardVuParams'
import { useEffect, useRef, useState } from 'react'
import Sortable from 'sortablejs'
import { setVuObjectInfoStore } from '../../Redux/VisualUnits/visualUnitStateSlice'
import {VisualUnitApiDTO_EditSaveVisualUnit} from '../../Interfaces/APIContracts/VisualUnitApiDTO_EditSaveVisualUnit'
import { useDispatch } from 'react-redux'
import { FoundationsConstants } from '../../FoundationsConstants'
import { useApplyHighlight } from '../../GenericComponents/useApplyHighlight'

const MeasureFrame = (props: {
    availMeasures: Imeasures[]
    vuId: number
    setAvailMeasures: any
    setVuObj: any
    vuObj: string
    showUpdateMeasureDialog: Function,
    displayFieldErrors: (addedCount: number, callFrom: "add" | "save", action: "measure" | "dimensionRow" | "dimensionColumn") => void
    setShowSaveandSaveAs: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const { availMeasures, vuId, setAvailMeasures, setVuObj, vuObj, showUpdateMeasureDialog, displayFieldErrors,setShowSaveandSaveAs } =
        props
    const { applyHighlight, highlightClass } = useApplyHighlight(FoundationsConstants.APPLY_HIGHLIGHT_DURATION);
    const listRef = useRef<HTMLOListElement>(null)
    const [draggedItemIndex, setDraggedItemIndex] = useState<number | null>(null)
    let dispatch = useDispatch()
    const deleteMeasure = (event: any, itrIndex: number) => {
        event.stopPropagation()
        let _vuIndex = getVisualUnitParamsIndex(vuId, JSON.parse(vuObj))
        let indexedVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]
        let availMeasureList = [...availMeasures]
        availMeasureList = availMeasureList.filter((_, index) => index !== itrIndex)

        let addedMeasuresPayload = indexedVuObj[_vuIndex].measures
        addedMeasuresPayload = addedMeasuresPayload.filter(
            (_: any, index: number) => index !== itrIndex
        )

        indexedVuObj[_vuIndex].measures = addedMeasuresPayload

        setAvailMeasures(availMeasureList)
        setVuObj(JSON.stringify(indexedVuObj))
        dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
        displayFieldErrors(addedMeasuresPayload.length, "add", "measure")
        setShowSaveandSaveAs(false)
    }

    const previousLengthRef = useRef(availMeasures.length);

    useEffect(() => {
        //FP-12106
        const prevLen = previousLengthRef.current;
        const newLen = availMeasures.length;
        if (newLen > prevLen) {
            // New measure added at the beginning? (or use newLen - 1)
            const newIndex = prevLen;
            const id = `add_measure_${newIndex}`;

            setTimeout(() => {
                applyHighlight(id, 'applyHighLight', { autoHide: false });
            }, 0);
        }
        previousLengthRef.current = newLen;
    }, [availMeasures.length]);

    const handleDragStart = (index: number) => {
        setDraggedItemIndex(index)
    }

    const handleDragOver = (event: React.DragEvent<HTMLLIElement>) => {
        event.preventDefault()
    }

    const handleDrop = (index: number) => {
        if (draggedItemIndex === null || draggedItemIndex === index) return
        let _vuIndex = getVisualUnitParamsIndex(vuId, JSON.parse(vuObj))
        const reorderedList = [...availMeasures]
        let indexedVuObj: VisualUnitApiDTO_EditSaveVisualUnit[] = [...JSON.parse(vuObj)]
        let addedMeasuresPayload = [...indexedVuObj[_vuIndex].measures]

        const [draggedItem] = reorderedList.splice(draggedItemIndex, 1)
        const [draggedPayloadItem] = addedMeasuresPayload.splice(draggedItemIndex, 1)

        reorderedList.splice(index, 0, draggedItem)
        addedMeasuresPayload.splice(index, 0, draggedPayloadItem)

        indexedVuObj[_vuIndex].measures = addedMeasuresPayload

        setAvailMeasures(reorderedList)
        setVuObj(JSON.stringify(indexedVuObj))

        dispatch(setVuObjectInfoStore({ data: indexedVuObj }))
        setDraggedItemIndex(null)
        if (reorderedList.length <= FoundationsConstants.ALLOWED_MEASURES) {
            displayFieldErrors(reorderedList.length, "save", "measure")
        }
    }

    // useEffect(() => {
    //     console.log('inside use effect..')
    //     if (listRef.current) {
    //       const sortable = new Sortable(listRef.current, {
    //         animation: 150, // Smooth animation (in milliseconds)
    //       //  handle: ".drag-handle", // Only allow dragging by the handle
    //         onEnd: (event) => {
    //           const { oldIndex, newIndex } = event;
    //           console.log('old index', oldIndex)
    //           console.log('new index', newIndex)

    //           if (oldIndex !== undefined && newIndex !== undefined) {
    //             const updatedList = [...availMeasures];
    //             const [movedItem] = updatedList.splice(oldIndex, 1);
    //             updatedList.splice(newIndex, 0, movedItem);
    //             console.log('updated list..',updatedList)
    //             setAvailMeasures(updatedList);
    //           }
    //         },
    //       });

    //       // Cleanup Sortable instance on component unmount
    //       return () => {
    //         sortable.destroy();
    //       };
    //     }
    //   }, [availMeasures]);

    return (
        <ol ref={listRef} id={`vu_params_measures_list_${vuId}`} className="ui-sortable">
            {availMeasures &&
                availMeasures.map((measure: Imeasures, _index: number) => {
                    return (
                        <li key={`measure_item_${_index}`}
                            draggable
                            onDragStart={() => handleDragStart(_index)}
                            onDragOver={handleDragOver}
                            onDrop={() => handleDrop(_index)}
                            id={`vu_params_measure_${vuId}_${_index}`}
                            className={`vu-button ui-state-default ui-corner-all vu-object pos-relative clear-both measure 
                                ui-sortable-handle
                                ${highlightClass[`add_measure_${_index}`] ?? ""}
                                `}
                            data-metadataid="811"
                            onClick={() => {
                                showUpdateMeasureDialog(
                                    vuId,
                                    measure.vuIndex,
                                    measure.measure_index,
                                    true,
                                    'updateMeasure',
                                    measure,
                                    _index
                                )
                            }}
                        >
                            <a
                                id={`vu_params_measure_delete_${vuId}_${_index}`}
                                className="vu-object-delete-container"
                                href="javascript:void(0);"
                                onClick={(event) => deleteMeasure(event, _index)}
                            >
                                <span className="vu-object-delete"></span>
                            </a>
                            <div className="bluebox-title measure-info">{measure.measureName}</div>
                            <div className="bluebox-subtitle aggregate-info">
                                {measure.aggegrateFunctionName}
                            </div>
                            <div className="bluebox-content measure-info-desc">{measure.measureDescription}</div>
                        </li>
                    )
                })}
        </ol>
    )
}

export default MeasureFrame
